import { TabLinks } from "components/TabLinks";
import { useBreadcrumb } from "hooks/useBreadcrumbs";
import { Outlet, useLocation } from "react-router-dom";

import { useUnreachedOrganizationCount } from "./unreachedOrganizationsQuery";

export const NOTIFICATIONS_PATH = "/staff/notifications";
export const UNREACHED_ORGANIZATIONS_PATH = `${NOTIFICATIONS_PATH}/unreached`;

/**
 * The staff Notifications screen: what was sent, and the organizations whose alerts
 * reach no one. The second tab's label carries their count, so the gap shows without
 * opening it.
 */
export function NotificationsTabs() {
  useBreadcrumb({ label: "Notifications", to: NOTIFICATIONS_PATH });
  const { pathname } = useLocation();
  const count = useUnreachedOrganizationCount();

  const tabs = [
    { title: "Sent", to: NOTIFICATIONS_PATH },
    {
      title: count === undefined ? "Reaching no one" : `Reaching no one (${count})`,
      to: UNREACHED_ORGANIZATIONS_PATH,
    },
  ];
  const value = pathname.startsWith(UNREACHED_ORGANIZATIONS_PATH)
    ? UNREACHED_ORGANIZATIONS_PATH
    : NOTIFICATIONS_PATH;

  return (
    <>
      <TabLinks tabs={tabs} value={value} aria-label="Notifications tabs" />
      <Outlet />
    </>
  );
}
